import { Avatar, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { IoCaretDownSharp } from 'react-icons/io5';
import IMAGES from '../../constants/images';

const { Option } = Select;

const SelectLanguage = () => {
    const { t, i18n } = useTranslation('shared', { keyPrefix: 'LANGUAGES' });

    const changeLanguage = (locale: string) => {
        i18n.changeLanguage(locale);
    };

    return (
        <div className="language">
            <Select
                value={i18n.resolvedLanguage}
                onChange={changeLanguage}
                suffixIcon={<IoCaretDownSharp />}
            >
                <Option value="es">
                    <Avatar
                        src={IMAGES.languages.spanish}
                        style={{
                            marginRight: 8,
                            width: 26,
                            height: 14,
                        }}
                        shape="square"
                    />
                    {t('SPANISH')}
                </Option>
                <Option value="en">
                    <Avatar
                        src={IMAGES.languages.english}
                        style={{
                            marginRight: 8,
                            width: 32,
                            height: 20,
                        }}
                        shape="square"
                    />
                    {t('ENGLISH')}
                </Option>
                <Option value="pt">
                    <Avatar
                        src={IMAGES.languages.portuguese}
                        style={{
                            marginRight: 8,
                            width: 32,
                            height: 20,
                        }}
                        shape="square"
                    />
                    {t('PORTUGUESE')}
                </Option>
            </Select>
        </div>
    );
};

export default SelectLanguage;
